import { ActionType, createAsyncAction } from "typesafe-actions";

import { AnyEntityId, EntityTypeSupportingNotes } from "@mapmycustomers/shared/types/entity";
import Note from "@mapmycustomers/shared/types/entity/common/Note";

export const createNote = createAsyncAction(
  "@component/addNoteModal/createNote/request",
  "@component/addNoteModal/createNote/success",
  "@component/addNoteModal/createNote/failure"
)<
  {
    callback: (note: Note) => void;
    entityId: AnyEntityId;
    entityType: EntityTypeSupportingNotes;
    note: string;
  },
  void,
  void
>();

export type Actions = ActionType<typeof createNote>;
